/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/document/AcknowledgementScreenConfiguration.yaml
import { BackgroundStyle, BarButtonConfiguration, IconStyle, StyledText } from '../common/Common';
/** @hidden */
export const AcknowledgementModeValues = [
    'UNACCEPTABLE_QUALITY',
    'ALWAYS',
    'NONE',
];
/**
Configuration for proceed anyway button in different quality scenarios.
*/
export class AcknowledgementProceedAnywayButton {
    /** @param source {@displayType `DeepPartial<AcknowledgementProceedAnywayButton>`} */
    constructor(source = {}) {
        /**
          Whether the proceed anyway button is visible.
          
          Default is true
          */
        this.visible = true;
        /**
          Text shown when document is not found.
          */
        this.documentNotFound = new BarButtonConfiguration({
            visible: true,
            title: new StyledText({ text: '?proceedAnywayButtonDocumentNotFound' }),
            accessibilityDescription: '?accessibilityDescriptionProceedAnywayButtonDocumentNotFound',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Text shown when document quality is unacceptable.
          */
        this.unacceptableQuality = new BarButtonConfiguration({
            visible: false,
            title: new StyledText({ text: '?proceedAnywayButtonUnacceptableQuality', color: '?sbColorOnPrimary' }),
            accessibilityDescription: '?accessibilityDescriptionProceedAnywayButtonUnacceptableQuality',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Text shown when document quality is uncertain.
          */
        this.uncertainQuality = new BarButtonConfiguration({
            visible: true,
            title: new StyledText({ text: '?proceedAnywayButtonUncertainQuality', color: '?sbColorOnPrimary' }),
            accessibilityDescription: '?accessibilityDescriptionProceedAnywayButtonUncertainQuality',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.documentNotFound !== undefined) {
            this.documentNotFound = new BarButtonConfiguration(source.documentNotFound);
        }
        if (source.unacceptableQuality !== undefined) {
            this.unacceptableQuality = new BarButtonConfiguration(source.unacceptableQuality);
        }
        if (source.uncertainQuality !== undefined) {
            this.uncertainQuality = new BarButtonConfiguration(source.uncertainQuality);
        }
    }
}
/**
Configuration for warning display in different quality scenarios.
*/
export class AcknowledgementDocumentQualityWarning {
    /** @param source {@displayType `DeepPartial<AcknowledgementDocumentQualityWarning>`} */
    constructor(source = {}) {
        /**
          Whether the warning is visible.
          
          Default is false
          */
        this.visible = false;
        /**
          Text configuration for the warning.
          */
        this.title = new StyledText({ text: '?acknowledgementWarning', color: '?sbColorOnPrimary' });
        /**
          Background color for the warning.
          */
        this.background = new BackgroundStyle({});
        /**
          Configuration of the icon appearance.
          */
        this.icon = new IconStyle({});
        if (source.visible !== undefined) {
            this.visible = source.visible;
        }
        if (source.title !== undefined) {
            this.title = new StyledText(source.title);
        }
        if (source.background !== undefined) {
            this.background = new BackgroundStyle(source.background);
        }
        if (source.icon !== undefined) {
            this.icon = new IconStyle(source.icon);
        }
    }
}
/**
Configuration of the bottom bar for the acknowledgement screen.
*/
export class AcknowledgementBottomBar {
    /** @param source {@displayType `DeepPartial<AcknowledgementBottomBar>`} */
    constructor(source = {}) {
        /**
          Configuration of the 'retake' button.
          */
        this.retakeButton = new BarButtonConfiguration({
            title: new StyledText({ text: '?acknowledgementRetakeButtonTitle', color: '?sbColorOnPrimary' }),
            accessibilityDescription: '?accessibilityDescriptionAcknowledgementRetakeButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Configuration of the 'accept' button, when the quality of the scanned page is acceptable.
          */
        this.acceptWhenAcceptableButton = new BarButtonConfiguration({
            title: new StyledText({ text: '?acknowledgementAcceptButtonTitle', color: '?sbColorOnPrimary' }),
            accessibilityDescription: '?accessibilityDescriptionAcknowledgementAcceptButton',
            background: new BackgroundStyle({ strokeColor: '#00000000', fillColor: '#00000000', strokeWidth: 0.0 }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Configuration of proceed anyway button for different quality scenarios.
          */
        this.proceedAnywayButton = new AcknowledgementProceedAnywayButton({});
        if (source.retakeButton !== undefined) {
            this.retakeButton = new BarButtonConfiguration(source.retakeButton);
        }
        if (source.acceptWhenAcceptableButton !== undefined) {
            this.acceptWhenAcceptableButton = new BarButtonConfiguration(source.acceptWhenAcceptableButton);
        }
        if (source.proceedAnywayButton !== undefined) {
            this.proceedAnywayButton = new AcknowledgementProceedAnywayButton(source.proceedAnywayButton);
        }
    }
}
/**
Configuration of the acknowledgement screen.
*/
export class AcknowledgementScreenConfiguration {
    /** @param source {@displayType `DeepPartial<AcknowledgementScreenConfiguration>`} */
    constructor(source = {}) {
        /**
          Configuration of the title, located in the top bar.
          */
        this.topBarTitle = new StyledText({
            visible: false,
            text: '?acknowledgementTitle',
            color: '?sbColorOnPrimary',
        });
        /**
          Determines, after each page is snapped, whether the acknowledgment screen should be displayed or not.
          
          Default is ALWAYS
          */
        this.acknowledgementMode = 'ALWAYS';
        /**
          The background color of the acknowledgement screen.
          
          Default is "?sbColorOutline"
          */
        this.backgroundColor = '?sbColorOutline';
        /**
          Configuration of the bottom bar for the acknowledgement screen.
          */
        this.bottomBar = new AcknowledgementBottomBar({});
        /**
          Configuration for warning display when document is not found.
          */
        this.documentNotFoundWarning = new AcknowledgementDocumentQualityWarning({
            visible: true,
            title: new StyledText({ text: '?acknowledgementWarningDocumentNotFound' }),
            background: new BackgroundStyle({
                strokeColor: '?sbColorNegative',
                fillColor: '?sbColorNegative',
                strokeWidth: 0.0,
            }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Configuration for warning display when document quality is unacceptable.
          */
        this.unacceptableQualityWarning = new AcknowledgementDocumentQualityWarning({
            visible: true,
            title: new StyledText({ text: '?acknowledgementWarningUnacceptableQuality' }),
            background: new BackgroundStyle({
                strokeColor: '?sbColorNegative',
                fillColor: '?sbColorNegative',
                strokeWidth: 0.0,
            }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        /**
          Configuration for warning display when document quality is uncertain.
          */
        this.uncertainQualityWarning = new AcknowledgementDocumentQualityWarning({
            visible: true,
            title: new StyledText({ text: '?acknowledgementWarningUncertainQuality' }),
            background: new BackgroundStyle({
                strokeColor: '?sbColorNegative',
                fillColor: '?sbColorNegative',
                strokeWidth: 0.0,
            }),
            icon: new IconStyle({ color: '?sbColorOnPrimary' }),
        });
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = new StyledText(source.topBarTitle);
        }
        if (source.acknowledgementMode !== undefined) {
            this.acknowledgementMode = source.acknowledgementMode;
        }
        if (source.backgroundColor !== undefined) {
            this.backgroundColor = source.backgroundColor;
        }
        if (source.bottomBar !== undefined) {
            this.bottomBar = new AcknowledgementBottomBar(source.bottomBar);
        }
        if (source.documentNotFoundWarning !== undefined) {
            this.documentNotFoundWarning = new AcknowledgementDocumentQualityWarning(source.documentNotFoundWarning);
        }
        if (source.unacceptableQualityWarning !== undefined) {
            this.unacceptableQualityWarning = new AcknowledgementDocumentQualityWarning(source.unacceptableQualityWarning);
        }
        if (source.uncertainQualityWarning !== undefined) {
            this.uncertainQualityWarning = new AcknowledgementDocumentQualityWarning(source.uncertainQualityWarning);
        }
    }
}
//# sourceMappingURL=AcknowledgementScreenConfiguration.js.map